import React, { useEffect, useState, useRef } from 'react';
import styles from './Header.module.css';
import HashParameterService from '../../../services/hashParameterService';

const logoSrc = require('../../../images/bmo-logo.png');

const Header = ({
    customerName,
    showExportButton,
    activeMainMenu,
    setActiveMainMenu,
    showHeaderDRButton,
    showOverviewButton,
    headerDRButtonExtraText,
    showLabel=false,
    label="",
    showSubLabel=false,
    subLabel=""

}) => {
    const [extraCampaignText, setExtraCampaignText] = useState('');
    const [hasOverflow, setHasOverflow] = useState(false);
    const navTextRef = useRef(null);
    const hashParamService = new HashParameterService();

    useEffect(() => {
        if (headerDRButtonExtraText !== undefined && headerDRButtonExtraText !== '') {
            setExtraCampaignText(' - ' + headerDRButtonExtraText);
        } else {
            setExtraCampaignText('');
        }
    }, [headerDRButtonExtraText]);

    useEffect(() => {
        const checkNavTextOverflow = () => {
            if (navTextRef.current) {
                // Compare the actual text width with its containing element width
                const hasTextOverflow = navTextRef.current.scrollWidth > navTextRef.current.offsetWidth;
                setHasOverflow(hasTextOverflow);
            }
        };

        checkNavTextOverflow();
        window.addEventListener('resize', checkNavTextOverflow);
        return () => window.removeEventListener('resize', checkNavTextOverflow);
    }, [extraCampaignText]);

    const renderDeliveryReport = () => {
        const content = `Delivery Report${extraCampaignText}`;
        const className = `${activeMainMenu === 'Delivery Report' ? styles.active : ''}`;

        if (hasOverflow) {
            return (
                <li className={`pop-tooltip ${className}`} onClick={() => setActiveMainMenu('Delivery Report')}>
                    <span className={styles.navLinkEllipsis} ref={navTextRef}>
                        {content}
                    </span>
                    <span className="pop-tooltiptext">
                        {content}
                    </span>
                </li>
            );
        }

        return (
            <li className={className} onClick={() => setActiveMainMenu('Delivery Report')}>
                <span className={styles.navLink} ref={navTextRef}>
                    {content}
                </span>
            </li>
        );
    };

    return (
        <div className={styles.header}>
            <div className={styles.leftText}>{customerName}</div>
            <nav className={styles.mainNav}>
                {setActiveMainMenu &&
                    <ul>
                        {showOverviewButton && (
                            <li
                                className={activeMainMenu === 'Overview' ? styles.active : ''}
                                onClick={() => {
                                    hashParamService.removeParameter('orderlines');
                                    setActiveMainMenu('Overview');
                                }}
                            >
                                Overview
                            </li>
                        )}
                        {showHeaderDRButton && renderDeliveryReport()}
                    </ul>
                }
                {showLabel && 
                    <div className={styles.centerText}>
                        {label}
                    </div>
                }
                {showSubLabel &&
                    <div className={styles.centerText}>
                        {subLabel}
                    </div>
                }
            </nav>
            <div className={styles.logoContainer}>
                <img src={logoSrc} alt="Bauer Media Outdoor logo" className={styles.logo} />
                <p className={styles.headerText}>Proof of Delivery</p>
            </div>
        </div>
    );
};

export default Header;